import moment from "moment";

const formatDayMonth = (date: string): string => moment(date).format('D. MMM');

const formatDayMonthTime = (date: string): string => moment(date).format('DD. MMM HH:mm');

export const formatWorkOrderDateRange = (
    start?: string,
    end?: string,
): string | null => {
    if (!start && !end) {
        return null;
    }
    if (start && end) {
        const isSameDay = moment(start).isSame(end, 'day');
        if (isSameDay) {
            // Show both times if both on the same date
            return `${formatDayMonthTime(start)} – ${moment(end).format('HH:mm')}`;
        }
        // Different days, show only date
        return `${formatDayMonth(start)} – ${formatDayMonth(end)}`;
    }
    if (start) {
        return formatDayMonth(start);
    }
    return end ? formatDayMonth(end) : null;
};